export default __webpack_public_path__ + "static/realWorldImage2-46fa4b531dc76fb4b8a21ea8f859af70.webp";